module.exports = {
	"contract_plans": {
		"attributes": {
			"statuses": {
				"active": "Ativo",
				"inactive": "Inativo",
				"finished": "Finalizado"
			}
		},
		"errors": {
			"not_selected": "Não pode ficar em branco"
		},
		"placeholder": {
			"search_by_plan_name": "Pesquise por nome do plano..."
		},
		"alerts": {
			"success": {
				"change": "Plano alterado.",
				"inactivate": "Plano inativado com sucesso!",
				"new_plan": "Novo plano adicionado com sucesso",
				"update": "Atualizações realizadas com sucesso"
			},
			"fail": {
				"inactivate": "Falha ao inativar o plano",
				"update": "Falha ao aplicar atualizações",
				"new_plan": "Falha ao adicionar novo plano"
			}
		},
		"buttons": {
			"activate": "Ativar",
			"inactivate": "Inativar"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/yaml-loader!./src/lang/contract_plans/pt-BR.yml
// module id = 578
// module chunks = 1